export default __webpack_public_path__ + "static/media/e.f5268648.png";